<template>
  <div class="event">
    <h4 class="label">{{ postTypeText }}{{ $t('labels.date.start') }} - {{ $t('labels.date.end') }}</h4>

    <ValidationProvider
      v-slot="{ errors, value, handleChange }"
      v-model="eventDate"
      :rules="eventDateRules"
      :name="$t('labels.date.value')"
    >
      <DatePicker
        :initial-dates="value"
        opens="right"
        :disabled-dates="disabledDates"
        :is-interactive="true"
        @input="handleChange"
      />

      <ValidationError id="eventDate" :error="errors[0]" />
    </ValidationProvider>

    <ul class="c-checkbox">
      <li class="c-checkbox__item">
        <input id="eventTime" v-model="eventTimeToggle" type="checkbox" class="c-checkbox__input">
        <label class="c-checkbox__label" for="eventTime">
          {{ $t('labels.add', {value: $t('labels.time.value')}) }}
        </label>
      </li>
    </ul>

    <div v-if="eventTime" class="event__time">
      <div>
        <ValidationProvider
          v-slot="{ errors, value }"
          name="開始時間"
          :model-value="eventStartedTime"
          :rules="eventTimeRules"
          @update:model-value="updateEventStartedTime"
        >
          <h4 class="label">{{ $t('labels.time.start') }}</h4>
          <SuggestField
            id="startedTime"
            :value="value"
            :placeholder="'00:00'"
            :suggests="timeList"
            @select-suggest="selectSuggest"
            @close-suggest="() => {}"
            @focus-field="() => {}"
            @input-field="inputField"
          />

          <ValidationError id="startedTime" :error="errors[0]" />
        </ValidationProvider>
      </div>

      <div>
        <ValidationProvider
          v-slot="{ errors, value }"
          name="終了時間"
          :model-value="eventEndedTime"
          :rules="eventTimeRules"
          @update:model-value="updateEventEndedTime"
        >
          <h4 class="label">{{ $t('labels.time.end') }}</h4>
          <SuggestField
            id="endedTime"
            :value="value"
            :placeholder="'00:00'"
            :suggests="timeList"
            @select-suggest="selectSuggest"
            @close-suggest="() => {}"
            @focus-field="() => {}"
            @input-field="inputField"
          />

          <ValidationError id="endedTime" :error="errors[0]" />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import ValidationError from '../ValidationError'
import DatePicker from '../DatePicker'
import moment from 'moment'
import SuggestField from '../SuggestField'

export default {
  name: 'Event',
  components: {
    ValidationError,
    DatePicker,
    SuggestField
  },
  computed: {
    ...mapState({
      post: state => state.companiesStorePosts.post,
      eventTime: state => state.companiesStorePosts.eventTime,
      eventStartedTime: state => state.companiesStorePosts.eventStartedTime,
      eventEndedTime: state => state.companiesStorePosts.eventEndedTime,
    }),
    ...mapGetters({
      timeList: 'companiesStorePosts/timeList',
      showSubmitActionModalType: 'companiesStorePosts/showSubmitActionModalType'
    }),
    postTypeText() {
      if (this.post.topicType === 'EVENT') {
        return `${this.$t('models.gmb.topicType.event')}の`
      } else if (this.post.topicType === 'OFFER') {
        return `${this.$t('models.gmb.topicType.offer')}の`
      }
      return ''
    },
    eventDate: {
      get() {
        return {
          startDate: this.post.event.startedAt,
          endDate: this.post.event.endedAt,
        }
      },
      set(eventDate) {
        this.updateStartedAt(eventDate.startDate)
        this.updateEndedAt(eventDate.endDate)
      }
    },
    eventTimeToggle: {
      get() {
        return this.eventTime
      },
      set(eventTime) {
        this.updateEventTime(eventTime)
      }
    },
    eventDateRules() {
      if(this.showSubmitActionModalType === 'draft') {
        return ''
      }
      return this.post.topicType === 'EVENT' || this.post.topicType === 'OFFER' ? 'eventDate|required' : ''
    },
    eventTimeRules() {
      if(this.showSubmitActionModalType === 'draft') {
        return ''
      }
      return this.post.topicType === 'EVENT' || this.post.topicType === 'OFFER' ? 'time|required' : ''
    },
    disabledDates() {
      return {
        from: null,
        to: moment().add(12, 'month'),
      }
    },
  },
  methods: {
    ...mapMutations('companiesStorePosts', [
      'updateStartedAt',
      'updateEndedAt',
      'updateEventTime',
      'updateEventStartedTime',
      'updateEventEndedTime',
    ]),
    selectSuggest({ suggest, id }) {
      if (id === 'startedTime') {
        this.updateEventStartedTime(suggest.name)
      }
      if (id === 'endedTime') {
        this.updateEventEndedTime(suggest.name)
      }
    },
    inputField({ value, id }) {
      if (id === 'startedTime') {
        this.updateEventStartedTime(value)
      }
      if (id === 'endedTime') {
        this.updateEventEndedTime(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.event {
  .label {
    font-size: 12px;
    margin: 32px 0 8px;
  }
  .c-checkbox {
    margin: 16px 0 0;
  }

  .c-checkbox__label {
    font-size: 12px;
  }

  .c-checkbox__item {
    padding: 0;
  }

  &__example {
    margin-top: 8px;
  }

  :deep(.wrapper) {
    transform: translate(50%, -20%);
  }

  &__time {
    display: flex;
    justify-content: space-between;

    & > div {
      width: calc(50% - 8px);
    }
  }
}
</style>
